export const Logo = ({ size = 34 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    data-testid="backfill-logo"
    aria-label="Backfill logo"
  >
    <rect
      width="48"
      height="48"
      rx="10"
      fill="#12161F"
      stroke="rgba(242,95,34,0.45)"
    />
    <path
      d="M11 31 L20 22 L26 28 L37 16"
      stroke="#F25F22"
      strokeWidth="3.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30 16 H37 V23"
      stroke="#F25F22"
      strokeWidth="3.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 39 L18 32"
      stroke="#F25F22"
      strokeOpacity="0.45"
      strokeWidth="3.5"
      strokeLinecap="round"
    />
  </svg>
);

export default Logo;
